import { render, staticRenderFns } from "./entityDialogUserGroupAllot.vue?vue&type=template&id=5b03d8a2&"
import script from "./entityDialogUserGroupAllot.vue?vue&type=script&lang=js&"
export * from "./entityDialogUserGroupAllot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports